export type CategoryKey = 'alimentation' | 'boisson' | 'maison-decoration' | 'electronique'

export type CategorySubcategory = {
  label: string
  description: string
  products: string[]
}

export type Category = {
  key: CategoryKey
  title: string
  description: string
  image: string
  imageAlt: string
  products: string[]
  subcategories: CategorySubcategory[]
}

export const CATEGORIES: Category[] = [
  {
    key: 'alimentation',
    title: 'Alimentation',
    description: 'Une sélection complète de produits alimentaires, pensée pour vos approvisionnements professionnels.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/fe26f8d2-fd2f-49f6-b781-70f018ee88a1.jpg',
    imageAlt: 'Assortiment de produits alimentaires',
    products: ['Huile d’Olive', 'Fruits et Légumes', 'Fruits Frais', 'Fruits secs', 'Produits Laitiers', 'Viandes et Poissons'],
    subcategories: [
      {
        label: 'Huile d’Olive',
        description: 'Des huiles d’olive sélectionnées pour la restauration et les commerces.',
        products: ['Huile vierge extra', 'Huile douce', 'Formats professionnels'],
      },
      {
        label: 'Fruits et Légumes',
        description: 'Des légumes frais et des fruits de saison sélectionnés avec soin.',
        products: ['Légumes de saison', 'Primeurs', 'Herbes et aromates'],
      },
      {
        label: 'Fruits Frais',
        description: 'Une sélection de fruits frais pour vos rayons et vos besoins quotidiens.',
        products: ['Fruits de saison', 'Agrumes', 'Fruits rouges'],
      },
      {
        label: 'Fruits secs',
        description: 'Amandes, noisettes, noix et fruits séchés pour une offre gourmande.',
        products: ['Amandes', 'Noix', 'Fruits séchés'],
      },
      {
        label: 'Produits Laitiers',
        description: 'Crèmerie, lait, yaourts et fromages sélectionnés pour les professionnels.',
        products: ['Lait et crème', 'Fromages', 'Yaourts'],
      },
      {
        label: 'Viandes et Poissons',
        description: 'Viandes, volailles, poissons et fruits de mer pour vos approvisionnements frais.',
        products: ['Volaille', 'Viandes sélectionnées', 'Poissons et fruits de mer'],
      },
    ],
  },
  {
    key: 'boisson',
    title: 'Boisson',
    description: 'Des boissons variées pour répondre à chaque envie et à chaque moment de consommation.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6dc4aef4-54c9-4d18-95ba-267a349ce90f.jpg',
    imageAlt: 'Assortiment de boissons',
    products: ['Eaux & jus', 'Sodas', 'Boissons énergétiques', 'Boissons du monde'],
    subcategories: [],
  },
  {
    key: 'maison-decoration',
    title: 'Maison et Décoration',
    description: 'De l’équipement pratique aux objets qui donnent du caractère à chaque intérieur.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1b317910-912e-4f72-936e-ebb6c253b240.jpg',
    imageAlt: 'Sélection d’articles pour la maison et la décoration',
    products: ['Cuisine', 'Rangement', 'Arts de la table', 'Décoration'],
    subcategories: [],
  },
  {
    key: 'electronique',
    title: 'Électronique',
    description: 'Des équipements et accessoires utiles, avec le bon équilibre entre fiabilité et prix.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/681500df-95b8-48f0-8cac-7e637eca992d.jpg',
    imageAlt: 'Ordinateur portable moderne',
    products: ['Informatique', 'Accessoires', 'Petit électroménager', 'Audio & vidéo'],
    subcategories: [],
  },
]

export function getCategory(categoryKey: CategoryKey): Category {
  const category = CATEGORIES.find((item) => item.key === categoryKey)

  if (!category) {
    throw new Error(`Unknown category: ${categoryKey}`)
  }

  return category
}
